// extracted by mini-css-extract-plugin
module.exports = {"text":"DrawingIntroRight_text__1eSX7","lottieWrapper":"DrawingIntroRight_lottieWrapper__mxd9t","lottieSvg":"DrawingIntroRight_lottieSvg__MLuro"};